import React from "react";
import { Col, Row, Container } from "react-bootstrap";

import "./styles/cabecalho-form-boletim.css";

const CabecalhoBoletim = ({ texto }) => {
  return (
    <Container fluid className="bo-header">
      <Row className="align-items-center">
        <Col>
          <h1 className="bo-header-title">{texto}</h1>
        </Col>
      </Row>
    </Container>
  );
};

export default CabecalhoBoletim;
